/**
 * Decodes HTML entities back to plain text.
 *
 * @param html - The HTML-encoded string to decode
 * @returns The decoded plain text
 *
 * @example
 * htmlDecode('Hello &amp; world') => 'Hello & world'
 */
export const htmlDecode = (html: string): string => {
  const textarea = document.createElement('textarea')
  textarea.innerHTML = html

  return textarea.value
}
